import React from 'react';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';

const Logo: React.FC = () => {
    return (

        <>

            <Link to='/'>
                <div className={styles.logo1}>
                    <span className={styles.letterL}>L</span>
                    <span className={styles.letterE}>e</span>
                    <span className={styles.letterH}>h</span>
                    <span className={styles.letterU1}>o</span>
                    <span className={styles.letterZ}>z</span>
                    <span className={styles.letterO}>o</span>
                </div>

            </Link>

        </>
    )

}

export default Logo